
    var riot = require('riot')
    
riot.tag2('mydetails', '<div class="profile"> <form onsubmit="{handleSaveProfile}" class="form-horizontal"> <div class="row"> <div class="col-xs-12"> <forminput name="first_name" label="First Name" onupdate="{handleUpdate}" value="{user.first_name}" width1="3" width2="9"></forminput> <forminput name="surname" label="Surname" onupdate="{handleUpdate}" value="{user.surname}" width1="3" width2="9"></forminput> <forminput hide="{!user.student_membership?.match(/guest|member/i)}" name="email" label="Email" onupdate="{handleUpdate}" value="{user.email}" width1="3" width2="9"></forminput> <formstatic hide="{user.student_membership?.match(/guest|member/i)}" name="email" label="Email" onupdate="{handleUpdate}" value="{user.email}" width1="3" width2="9"></formstatic> <formtextarea name="address" isrequired label="Address" onupdate="{handleUpdate}" value="{user.address}" width1="3" width2="9"></formtextarea> <forminput name="city" label="City" onupdate="{handleUpdate}" value="{user.city}" width1="3" width2="9"></forminput> <formselect name="state" label="State" onupdate="{handleUpdate}" value="{user.state}" options="{stateCodes}" default="Select State" width1="3" width2="9" if="{user.country==\'US\'}"></formselect> <forminput name="postcode" label="Postcode" onupdate="{handleUpdate}" value="{user.postcode}" width1="3" width2="9"></forminput> <formselect name="country" isrequired label="Country" onupdate="{handleUpdate}" value="{user.country}" options="{countryCodes}" default="Select Country" width1="3" width2="9"></formselect> <forminput name="phone1" label="Telephone" onupdate="{handleUpdate}" value="{user.phone1}" width1="3" width2="9"></forminput> <forminput name="phone2" label="Mobile" onupdate="{handleUpdate}" value="{user.phone2}" width1="3" width2="9"></forminput> <div show="{user.student_membership}" class="alert alert-info col-xs-offset-3">Student {user.student_membership} Account</div> <div class="row"> <div class="col-xs-9 col-xs-offset-3"> <button type="submit" class="btn btn-primary">Update My Profile</button> </div> </div> <p><br></p> <div if="{message}" class="alert alert-success">{message}</div> <div if="{errormessage}" class="alert alert-danger">{errormessage}</div> </div> </div> </form> </div>', '.duoEditArea .form-control-static { margin-bottom: 0; } .profile .logout-btn { margin-bottom: -115px; } .profile .avatar { border: 1px solid #ccc; padding: 10px; margin-bottom: 20px; } .profile .avatar img { width: 100%; } .profile .row { margin-bottom: 10px; }', '', function(opts) {
var countryApi, profileApi, resource, stateApi;

resource = require('riot-kit/utils/apiResource.coffee');

profileApi = new resource('/duocms/api/users/me', true);

countryApi = new resource(opts.countrysrc || '/duocms/api/countries', true);

stateApi = new resource(opts.statesrc || '/duocms/api/states', true);

this.countryCodes = [];

this.stateCodes = [];

this.on("mount", function() {
  if (window.location.search.match(/editmode=/)) {
    this.root.innerHTML = "-- User Details Form --";
  }
  profileApi.get((function(_this) {
    return function(user) {
      _this.user = user;
      return _this.update();
    };
  })(this));
  countryApi.get((function(_this) {
    return function(countries) {
      _this.countryCodes = countries.map(function(country) {
        return {
          label: country.name,
          value: country.code
        };
      });
      return _this.update();
    };
  })(this));
  return stateApi.get((function(_this) {
    return function(states) {
      _this.stateCodes = states.map(function(state) {
        return {
          label: state.name,
          value: state.code
        };
      });
      return _this.update();
    };
  })(this));
});

this.handleLoggedOut = (function(_this) {
  return function() {
    _this.tags.profile.hide();
    return setTimeout(function() {
      return window.location.pathname = '/';
    }, 500);
  };
})(this);

this.close = (function(_this) {
  return function() {};
})(this);

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleUpdateTags = (function(_this) {
  return function(tags) {
    _this.user.tags = tags;
    return _this.update();
  };
})(this);

this.handleSignIn = (function(_this) {
  return function() {
    return _this.tags.signin.tags.signin.signin();
  };
})(this);

this.handleSignedIn = (function(_this) {
  return function() {
    _this.tags.signin.hide();
    return setTimeout(function() {
      return window.location.pathname = '/extranet/';
    }, 500);
  };
})(this);

this.handleSaveProfile = (function(_this) {
  return function(e) {
    console.log("handleSaveProfile");
    e.preventDefault();
    return _this.checkAddress()["catch"](function(errormessage) {
      _this.update({
        errormessage: errormessage
      });
      return setTimeout((function() {
        return _this.update({
          errormessage: false
        });
      }), 5000);
    }).then(function() {
      _this.user.id = null;
      if (!_this.errormessage) {
        console.log("saving profile", _this.user);
        return profileApi.save(_this.user, function(data) {
          console.log(data);
          _this.update({
            message: "Your profile has been successfully updated."
          });
          return setTimeout((function() {
            return _this.update({
              message: false
            });
          }), 3000);
        });
      }
    });
  };
})(this);

this.checkAddress = (function(_this) {
  return function(e) {
    var data;
    data = {
      address: _this.user.address,
      city: _this.user.city,
      state: _this.user.state,
      postcode: _this.user.postcode,
      country: _this.user.country
    };
    return fetch('/duocms/api/melissa/confirm', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.csrf
      },
      body: JSON.stringify(data)
    }).then(function(res) {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error("Could not verrify address. Please try again later.");
      }
    }).then(function(response) {
      var code, errormessage;
      errormessage = "";
      if (response.data.TotalRecords > 0) {
        code = response.data.Records[0].Results;
        if (code.match(/ae/i)) {
          errormessage = "The address you have supplied could not be validated. Please check your details and try again.";
        }
        if (code === "AE05") {
          errormessage = "You have supplied incomplete address information, which identifies more than one location. Please check your details and try again.";
        }
        if (code.includes("AV12") || code.includes("AV11") || code.includes("AV13") || code.includes("AV14")) {
          errormessage = "Your address doesn't contain enough information to be a full postall address. Please check your details and try again.";
        }
      } else {
        errormessage = "The address you have supplied could not be validated. Please check your details and try again.";
      }
      if (errormessage) {
        throw new Error(errormessage);
      }
    });
  };
})(this);

this.cachebuster = "";

this.uploadimage = (function(_this) {
  return function(file) {
    var formData, self, xhr;
    formData = new FormData();
    formData.append("file", file);
    xhr = new XMLHttpRequest();
    xhr.open('POST', '/duocms/api/britest/upload_avatar?_csrf=' + window.csrf, true);
    self = _this;
    xhr.onload = function() {
      var resp;
      resp = JSON.parse(this.response);
      self.cachebuster = +(new Date());
      return self.update();
    };
    return xhr.send(formData);
  };
})(this);
});
    
  